/* 
    This enum is intended to hold active a/b test buckets for this application. 
    It might sometimes be empty and thus redundant but it 
    is useful to have it in the code as a signpost of where 
    to collect these values.
*/
export enum AbTestNames {
    SEARCH_EVO_VANS = 'vgsrT',
    MOBILE_CAROUSEL_WITH_FOUR_IMAGESW = 'sicW',
    MOBILE_CAROUSEL_WITH_FOUR_IMAGESX = 'sicX',
    MOBILE_CAROUSEL_WITH_FOUR_IMAGESY = 'sicY',
    MOBILE_CAROUSEL_WITH_FOUR_IMAGESZ = 'sicZ',
    NEW_LEASING_CARD = 'slcT',

    CATEGORY_TAGS_IM_LOOKING_FOR = 'cflT',

    FLEXIBLE_FINANCE_FILTERS = 'flfiT',
    INTERCEPT_VALUATION_AND_RELEVANCE = 'siT',
}
